    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col-12">
                <h5 class="blue"><i class="fas fa-paper-plane"></i>&nbsp;Reenviar carga</h5>
            </div>
        </div>
        <hr>
        <form #formReenvio="ngForm" (ngSubmit)="formSubmit(formReenvio)" novalidate="">
            <div class="container-fuid" style="height: 180px; overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
                <div class="row mt-2" style="margin-right: 0px; margin-left: 0px;">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="form-group">
                            <label>Justificación:</label>
                            <br>
                            <textarea autocomplete="off" [readonly]="seReenvio" class="form-control form-control-sm custom-input" placeholder="Justifica el reenvío" 
                                name="txtJustificacion" #txtJustificacion="ngModel" [rows]="4" [(ngModel)]='reenvioRQ.justificacion' 
                                pattern="^[a-zA-Z0-9À-ÿñÑ\s]{2,}$"   required></textarea>
                        </div>
                    </div>
                </div> 
            </div>
            <div class="row mt-4">
                <div class="col text-end">
                    <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                                <i class="fa fa-arrow-left"></i>
                                Regresar
                    </button>
                    <button type="submit" [disabled]="!formReenvio.form.valid || !isValid" class="side-space btn btn-sm rounded-button btn-success">
                        Reenviar
                        <i class="fa fa-check"></i>
                    </button>
                </div>
            </div>
        </form>
    </div>